import { currentRefinements } from 'instantsearch.js/es/widgets';
import { getTranslation } from '../../getTranslation';

export const initCurrentRefinements = () => {
	const appliedFacetsBadges = document.querySelector('.applied-facets__badges');

	return currentRefinements({
		container: appliedFacetsBadges,
		cssClasses: {
			noRefinementRoot: 'applied-facets-no-results',
			list: 'applied-facets__list',
			item: 'applied-facets__list-item',
			delete: 'applied-facets__delete',
		},
		transformItems(items) {
			return items?.map(item => ({
				...item,
				label: getTranslation(item.label),
			}));
		},
	});
};
